<digital-platform-alert-banner></digital-platform-alert-banner>

<div class="header" *ngIf="pageContent">
  <header>
    <nav
      class="navbar navbar-expand-lg bg-dark text-light"
      style="height: 55px"
    >
      <div class="container d-flex flex-nowrap">
        <ul
          class="navbar-nav ms-md-auto flex-row d-flex justify-content-around justify-content-md-end w-100"
          data-automation-id="navbar"
        >
          <ng-container
            *ngFor="let item of pageContent.utility_links; index as i"
          >
            <!-- Hide nav items that don't have a link url -->
            <ng-container *ngIf="item.link_url">
              <li
                class="{{ !item.mobile_title ? 'd-none d-sm-block' : '' }}"
                class="nav-item d-flex justify-content-center"
              >
                <a
                  class="nav-link custom-nav-link d-flex align-items-center text-light ps-5 pe-5"
                  [href]="item.link_url"
                  (click)="navigate($event, item.link_url)"
                  [attr.data-automation-id]="item.link_title"
                >
                  <img
                    [src]="'/assets/' + icons[i] + '.svg'"
                    [alt]="item.link_title + ' Icon'"
                  />
                  <span class="d-sm-none ms-4 custom-nav-text text-nowrap">{{
                    item.mobile_title
                  }}</span>
                  <span
                    class="d-none d-sm-flex ms-3 custom-nav-text text-nowrap"
                    >{{ item.link_title }}</span
                  >
                </a>
              </li>
            </ng-container>
          </ng-container>
        </ul>
      </div>
    </nav>
  </header>
  <digital-platform-nav [config]="pageContent" [icons]="icons">
    <ng-container login>
      <digital-platform-account-dropdown-button></digital-platform-account-dropdown-button>
    </ng-container>
  </digital-platform-nav>
</div>
<!-- Render BOA Header component  -->
<router-outlet></router-outlet>
